<template>
    <div class="screen-with-sidebar">
        <aside class="">
            <div class="sidebar d-flex flex-column align-items-xl-center">
                <!-- logo -->
                <div class="sidebar__header mb-4 align-self-start">
                    <img
                        src="/assets/v3/image/logo_white.png"
                        alt=""
                        width="170px"
                        @click="goToHome"
                    />
                </div>
                <!-- Sidebar Main Content -->
                <div class="sidebar__main mb-4">
                    <div
                        class="row justify-content-between align-items-center mb-4 pb-4 border-bottom-white"
                        data-aos="fade-up"
                        data-aos-duration="1000"
                    >
                        <div class="col">
                            <small>Scheduling your appointment regarding</small>
                            <!-- <h3>{{ selectedAddress | showCity }}</h3> -->
                        </div>
                        <div class="col">
                            <small>
                                <b>{{ selectedAddress }}</b>
                            </small>
                        </div>
                    </div>
                    <div
                        data-aos="fade-up"
                        data-aos-duration="1000"
                        data-aos-delay="200"
                    >
                        <p class="mb-4">Meet our property specialists:</p>
                        <ul class="specialists">
                            <li class="mb-4">
                                <div class="avatar mr-3">
                                    <img src="/images/Srijana.jpg" alt="" />
                                </div>
                                <h4>Srijana</h4>
                            </li>
                            <li>
                                <div class="avatar mr-3">
                                    <img src="/images/Nisha.jpg" alt="" />
                                </div>
                                <h4>Nisha</h4>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sidebar__footer p-4">
                    <div>
                        <p>Feel free to give us a call at:</p>
                        <h4>905-296-7833</h4>
                    </div>
                    <div>
                        <i class="fa-solid fa-phone-volume h2"></i>
                    </div>
                </div>
            </div>
        </aside>
        <main class="flex-fill" style="overflow-x: hidden">
            <div class="main-conatiner">
                <h2 class="mb-5">{{ header_label }}</h2>
                <template v-if="step_two_visible == false">
                    <div class="schedule-options">
                        <!-- video-option -->
                        <input
                            type="radio"
                            name="meet-type"
                            id="video"
                            v-model="visit_type"
                            value="Phone Call"
                        />
                        <label for="video">
                            <i class="fa-solid fa-phone-volume h2"></i>
                            <h4>Phone call</h4>
                            <small
                                >Speak with a representative to understand our
                                selling options and choose whichever option
                                works best for you!</small
                            >
                        </label>
                        <!-- person-option -->
                        <input
                            type="radio"
                            name="meet-type"
                            id="person"
                            v-model="visit_type"
                            value="In Person"
                        />
                        <label for="person" style="opacity: 0.6">
                            <i class="fa-solid fa-user-group h1"></i>
                            <h4>In-Person</h4>
                            <small
                                >Schedule an in-person meeting to understand our
                                selling options.
                                <span class="text-danger"
                                    ><i>(Currently unavailable)</i></span
                                ></small
                            >
                        </label>
                    </div>
                </template>

                <!-- Step 2 -->
                <template v-if="step_two_visible && !step_three_visible">
                    <div class="mb-3">
                        <p class="mb-2">When are you available?</p>
                        <div class="schedule-options schedule-options--sm">
                            <!-- Morning -->
                            <input
                                type="radio"
                                name="time"
                                id="morning"
                                value="9 AM - 12 PM"
                                v-model="scheduled_time"
                            />
                            <label for="morning">
                                <small>Morning</small>
                                <p>9 AM - 12 PM</p>
                            </label>
                            <!-- --------- -->

                            <!-- Afternoon -->
                            <input
                                type="radio"
                                name="time"
                                id="afternoon"
                                value="12 PM - 4 PM"
                                v-model="scheduled_time"
                            />
                            <label for="afternoon">
                                <small>Afternoon</small>
                                <p>12 PM - 4 PM</p>
                            </label>
                            <!-- --------- -->

                            <!-- Evening -->
                            <input
                                type="radio"
                                name="time"
                                id="evening"
                                value="4 PM - 8 PM"
                                v-model="scheduled_time"
                            />
                            <label for="evening">
                                <small>Evening</small>
                                <p>4 PM - 8 PM</p>
                            </label>
                            <!-- --------- -->
                        </div>
                    </div>
                    <!-- ---------------------- Great, let's get specific ---------------------- -->
                    <div class="mb-3">
                        <p class="mb-2">Great, let's get specific</p>
                        <div class="schedule-options schedule-options--sm">
                            <!-- Date Option -->
                            <input
                                type="radio"
                                name="date"
                                id="Aug 11"
                                :value="dayItems[0].value"
                                v-model="scheduled_date"
                            />
                            <label for="Aug 11">
                                <!-- <small>{{ dayOne.label }}</small>
                    <p>{{ dayOne.value }}</p> -->
                                <small>{{ dayItems[0].label }}</small>
                                <p>{{ dayItems[0].value }}</p>
                            </label>

                            <!-- Date Option -->
                            <input
                                type="radio"
                                name="date"
                                id="Aug 12"
                                :value="dayItems[1].value"
                                v-model="scheduled_date"
                            />
                            <label for="Aug 12">
                                <!-- <small>{{ dayTwo.label }}</small>
                    <p>{{ dayTwo.value }}</p> -->
                                <small>{{ dayItems[1].label }}</small>
                                <p>{{ dayItems[1].value }}</p>
                            </label>

                            <!-- Date Option -->
                            <input
                                type="radio"
                                name="date"
                                id="Aug 13"
                                :value="dayItems[2].value"
                                v-model="scheduled_date"
                            />
                            <label for="Aug 13">
                                <!-- <small>{{ dayThree.label }}</small>
                    <p>{{ dayThree.value }}</p> -->
                                <small>{{ dayItems[2].label }}</small>
                                <p>{{ dayItems[2].value }}</p>
                            </label>
                        </div>
                    </div>
                    <!-- ---------------------- Please note all times are in EDT ---------------------- -->
                    <div class="mb-3">
                        <div class="row">
                            <div class="col">
                                <button
                                    @click="resetStepTwo"
                                    class="btn btn-outline-secondary btn-lg btn-block"
                                >
                                    Back
                                </button>
                            </div>
                            <div class="col">
                                <button
                                    @click="handleStepThree"
                                    class="btn btn-outline-secondary btn-lg btn-block"
                                >
                                    Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- ./Step 2 -->

                <!-- Step 3 -->
                <template v-if="step_three_visible">
                    <p class="mb-4">
                        One of our Home Specialists will be in touch shortly to
                        finalize your booking.
                    </p>
                    <form action="" class="review__form mb-4">
                        <div class="form-container m-4">
                            <!-- Name -->
                            <div class="form-group row justify-content-between">
                                <label class="col-sm-auto col-form-label"
                                    >Name</label
                                >
                                <div class="col-auto d-flex align-items-center">
                                    <input
                                        type="text"
                                        class="form-control mr-2 d-none"
                                        :value="name"
                                    />
                                    <b class="mr-2">{{ name }}</b>
                                </div>
                            </div>

                            <!-- Phone -->
                            <div class="form-group row justify-content-between">
                                <label class="col-sm-auto col-form-label"
                                    >Phone
                                </label>
                                <div class="col-auto d-flex align-items-center">
                                    <input
                                        type="text"
                                        class="form-control mr-2 d-none"
                                        :value="phone"
                                    />
                                    <b class="mr-2">{{ phone }}</b>
                                </div>
                            </div>

                            <!-- Email -->
                            <div class="form-group row justify-content-between">
                                <label class="col-sm-auto col-form-label"
                                    >Email
                                </label>
                                <div class="col-auto d-flex align-items-center">
                                    <input
                                        type="text"
                                        class="form-control mr-2 d-none"
                                        :value="email"
                                    />
                                    <b class="mr-2">{{ email }}</b>
                                </div>
                            </div>

                            <!-- Max Budget -->
                            <!-- <div class="form-group row justify-content-between">
                  <label class="col-sm-auto col-form-label">Max Budget </label>
                  <div class="col-auto d-flex align-items-center">
                    <input
                      type="text"
                      class="form-control mr-2 d-none"
                      value="6471231234"
                    />
                    <b class="mr-2">{{ to_price }}</b>
                  </div>
                </div> -->

                            <!-- Preferred move date -->
                            <div class="form-group row justify-content-between">
                                <label class="col-sm-auto col-form-label"
                                    >Preferred move date
                                </label>
                                <div class="col-auto d-flex align-items-center">
                                    <input
                                        type="text"
                                        class="form-control mr-2 d-none"
                                        :value="sell_frequency"
                                    />
                                    <b class="mr-2">{{ sell_frequency }}</b>
                                    <!-- <i class="fa-solid fa-pen-to-square" role="button"></i> -->
                                </div>
                            </div>

                            <!-- Tour type -->
                            <div class="form-group row justify-content-between">
                                <label class="col-sm-auto col-form-label"
                                    >Tour type
                                </label>
                                <div class="col-auto d-flex align-items-center">
                                    <b class="mr-2">{{ visit_type }}</b>
                                </div>
                            </div>

                            <!-- Home -->
                            <!-- Date and time -->
                            <div class="form-group row justify-content-between">
                                <label class="col-sm-auto col-form-label"
                                    >Date and time
                                </label>
                                <div class="col-auto d-flex align-items-center">
                                    <b class="mr-2"
                                        >{{ scheduled_time }},
                                        {{ scheduled_date }}</b
                                    >
                                </div>
                            </div>
                        </div>
                        <!-- Friendly Reminders -->
                        <!-- <div class="reminders bg-light p-4">
                <div class="reminders-header mb-3">
                  <h4>Friendly Reminders</h4>
                  <i class="fa-solid fa-circle-info h3"></i>
                </div>
                <div>
                  <ul class="reminders-list">
                    <li>
                      <i class="fa-solid fa-check text-success"></i>
                      <label>
                        This building has options for both private apartments and
                        coliving suites
                      </label>
                    </li>
                    <li>
                      <i class="fa-solid fa-check text-success"></i>
                      <label>
                        In coliving suites, your rent includes regular cleaning,
                        WiFi, utilities, and more
                      </label>
                    </li>
                    <li>
                      <i class="fa-solid fa-xmark text-secondary"></i>
                      <label>Pets are not permitted in coliving suites</label>
                    </li>
                  </ul>
                </div>
              </div> -->
                    </form>
                    <!-- ---------------------- Please note all times are in EDT ---------------------- -->
                    <div>
                        <button
                            class="btn btn-primary btn-lg btn-block"
                            @click="bookAppointment"
                        >
                            Confirm your appointment with us
                        </button>
                    </div>
                </template>
                <!-- ./Step 3 -->
            </div>
        </main>
    </div>
</template>

<script>
import axios from "axios";
import moment, { now } from "moment";
export default {
    name: "ValuationAppointment",
    data() {
        return {
            address: "191 Superior Blvd, Mississauga, ON L5T 2L6, Canada",
            visit_type: "",
            scheduled_time: "",
            scheduled_date: "",
            openStepThree: false,

            selectedAddress:
                "191 Superior Blvd, Mississauga, ON L5T 2L6, Canada",
            bedrooms: 0,
            bathrooms: 0,
            garage: 0,
            basement: "No",
            square_foot: 0,
            home_style: "N.A",
            home_type: "N.A",
            extra_details: "No details available",
            zip_code: "",
            latitude: "",
            longitude: "",
            valuation: {
                min: 0,
                average: 0,
                max: 0,
                properties: [],
            },
            seeMore: false,
            name: "",
            email: "",
            phone: "",
            another_house_buy_plan: "No",
            to_price: 0,
            from_price: 0,
            sell_frequency: "As soon as possible",
            isLoading: false,
            fullPage: true,
            userEmail: "",
            userPassword: "",
            authResult: "NO",
            alertClass: "",
            alertMessage: "",
            leadType: "seller",
        };
    },
    watch: {
        visit_type(value) {
            if (value == "In Person") {
                this.visit_type = "";
                alert("This option is currently unavailable");
            }
        },
    },
    computed: {
        step_two_visible() {
            if (this.visit_type) {
                return true;
            } else {
                return false;
            }
        },
        step_three_visible() {
            if (
                this.visit_type &&
                this.scheduled_date &&
                this.scheduled_time &&
                this.openStepThree
            ) {
                return true;
            } else {
                return false;
            }
        },
        header_label() {
            let label = "Schedule an appointment with our property specialists";
            if (this.step_two_visible && !this.step_three_visible) {
                label = "When are you available?";
            } else if (this.step_three_visible) {
                label = "Confirm your Appointment";
            }
            return label;
        },
        dayOne() {
            return {
                value: moment().add(1, "days").format("MMM Do YY"),
                label: moment().add(1, "days").format("dddd"),
            };
        },
        dayTwo() {
            return {
                value: moment().add(2, "days").format("MMM Do YY"),
                label: moment().add(2, "days").format("dddd"),
            };
        },
        dayThree() {
            return {
                value: moment().add(3, "days").format("MMM Do YY"),
                label: moment().add(3, "days").format("dddd"),
            };
        },
        dayItems() {
            let dayOne = {
                value: moment().add(1, "days").day("Sunday")
                    ? moment().add(2, "days").format("MMM Do YY")
                    : moment().add(1, "days").format("MMM Do YY"),
                label: moment().add(1, "days").day("Sunday")
                    ? moment().add(2, "days").format("dddd")
                    : moment().add(1, "days").format("dddd"),
            };

            let dayTwo = {
                value: moment().add(2, "days").day("Sunday")
                    ? moment().add(3, "days").format("MMM Do YY")
                    : moment().add(2, "days").format("MMM Do YY"),
                label: moment().add(2, "days").day("Sunday")
                    ? moment().add(3, "days").format("dddd")
                    : moment().add(2, "days").format("dddd"),
            };

            let dayThree = {
                value: moment().add(3, "days").day("Sunday")
                    ? moment().add(4, "days").format("MMM Do YY")
                    : moment().add(3, "days").format("MMM Do YY"),
                label: moment().add(3, "days").day("Sunday")
                    ? moment().add(4, "days").format("dddd")
                    : moment().add(3, "days").format("dddd"),
            };

            return [dayOne, dayTwo, dayThree];
        },
    },
    mounted() {
        if (sessionStorage.getItem("valuation_address")) {
            this.selectedAddress = sessionStorage.getItem("valuation_address");
        }
        if (sessionStorage.getItem("valuation_bed")) {
            this.bedrooms = sessionStorage.getItem("valuation_bed");
        }
        if (sessionStorage.getItem("valuation_bath")) {
            this.bathrooms = sessionStorage.getItem("valuation_bath");
        }
        if (sessionStorage.getItem("valuation_garage")) {
            this.garage = sessionStorage.getItem("valuation_garage");
        }
        if (sessionStorage.getItem("valuation_square_foot")) {
            this.square_foot = sessionStorage.getItem("valuation_square_foot");
        }
        if (sessionStorage.getItem("valuation_home_style")) {
            this.home_style = sessionStorage.getItem("valuation_home_style");
        }
        if (sessionStorage.getItem("valuation_property_type")) {
            this.home_type = sessionStorage.getItem("valuation_property_type");
        }
        if (sessionStorage.getItem("valuation_comment")) {
            this.extra_details = sessionStorage.getItem("valuation_comment");
        }
        if (sessionStorage.getItem("valuation_zip_code")) {
            this.zip_code = sessionStorage.getItem("valuation_zip_code");
        }
        if (sessionStorage.getItem("valuation_latitude")) {
            this.latitude = sessionStorage.getItem("valuation_latitude");
        }
        if (sessionStorage.getItem("valuation_longitude")) {
            this.longitude = sessionStorage.getItem("valuation_longitude");
        }
        if (sessionStorage.getItem("valuation_name")) {
            this.name = sessionStorage.getItem("valuation_name");
        }
        if (sessionStorage.getItem("valuation_email")) {
            this.email = sessionStorage.getItem("valuation_email");
        }
        if (sessionStorage.getItem("valuation_phone")) {
            this.phone = sessionStorage.getItem("valuation_phone");
        }
        if (sessionStorage.getItem("valuation_basement_present")) {
            this.basement = sessionStorage.getItem(
                "valuation_basement_present"
            );
        }
        if (sessionStorage.getItem("valuation_another_house_buy_plan")) {
            this.another_house_buy_plan = sessionStorage.getItem(
                "valuation_another_house_buy_plan"
            );
        }
        if (sessionStorage.getItem("valuation_to_price")) {
            this.to_price = sessionStorage.getItem("valuation_to_price");
        }
        if (sessionStorage.getItem("valuation_from_price")) {
            this.from_price = sessionStorage.getItem("valuation_from_price");
        }
        if (sessionStorage.getItem("valuation_sell_frequency")) {
            this.sell_frequency = sessionStorage.getItem(
                "valuation_sell_frequency"
            );
        }
        if (sessionStorage.getItem("lead_type")) {
            this.leadType = sessionStorage.getItem("lead_type");
        }
    },
    methods: {
        resetStepTwo() {
            this.visit_type = "";
        },
        handleStepThree() {
            if (this.scheduled_date && this.scheduled_time) {
                this.openStepThree = true;
            } else {
                alert("Select a time slot");
            }
        },
        fixAppointment() {
            window.location.href = "/schedule/appointment/success";
        },
        bookAppointment() {
            const formData = new FormData();

            formData.append("name", this.name);
            formData.append("email", this.email);
            formData.append("phone", this.phone);
            formData.append("date", this.scheduled_date);
            formData.append("time", this.scheduled_time);
            formData.append("lead_type", this.leadType);
            formData.append("message", this.extra_details);

            axios
                .post("/submit-callback-request", formData)
                .then((response) => {
                    this.fixAppointment();
                })
                .catch((error) => {
                    console.log(error);
                    alert("Unable to schedule appointment. Try after sometime");
                });
        },
        goToHome() {
            window.location.href = "/";
        },
    },
    filters: {
        showCity(val) {
            if (val && val.length) {
                return val.split(",")[1];
            }
            return val;
        },
    },
};
</script>
